import reelConfig from './hospitalityReel.json';

export const HOSPITALITY_REEL = reelConfig;

export interface HospitalityReelSources {
  webm: string;
  mp4: string;
  poster: string;
}

export function getHospitalityReelLanguage(locale: string): string {
  const base = (locale || '').split('-')[0].toLowerCase();
  return HOSPITALITY_REEL.languages.includes(base) ? base : HOSPITALITY_REEL.fallbackLanguage;
}

export function getHospitalityReelSources(locale: string): HospitalityReelSources {
  const prefix = `${HOSPITALITY_REEL.basePath}/${getHospitalityReelLanguage(locale)}`;
  const v = `?v=${HOSPITALITY_REEL.version}`;
  return {
    webm: `${prefix}.webm${v}`,
    mp4: `${prefix}.mp4${v}`,
    poster: `${prefix}-poster.webp${v}`,
  };
}

export function getHospitalityReelSharePath(locale: string): string {
  return `${HOSPITALITY_REEL.basePath}/${getHospitalityReelLanguage(locale)}/`;
}

export const HOSPITALITY_REEL_FRAME_MAX_WIDTH = `min(${HOSPITALITY_REEL.frameMaxWidthPx}px, calc((100vh - ${HOSPITALITY_REEL.frameViewportOffsetPx}px) * 16 / 9))`;
